import PoliceClearanceModule from '@features/Consular/components/police-clearance/PoliceClearance.Module';
import React from 'react';

const PoliceClearance = () => {
  return <PoliceClearanceModule />;
};

export default PoliceClearance;
